import React, { useState } from "react";
import TemplateListing from "./TemplateListing";
import TemplateCreation from "./TemplateCreation";

const Template = () => {
  const [showCreation, setShowCreation] = useState(false);
  const [selectedSampleTemplate, setSelectedSampleTemplate] = useState(null);
  const [editingTemplate, setEditingTemplate] = useState(null);

  const handleCreateNew = () => {
    setSelectedSampleTemplate(null);
    setEditingTemplate(null);
    setShowCreation(true);
  };

  const handleSelectSample = (template) => {
    setSelectedSampleTemplate(template);
    setEditingTemplate(null);
    setShowCreation(true);
  };

  const handleEditTemplate = (template) => {
    setEditingTemplate(template);
    setSelectedSampleTemplate(null);
    setShowCreation(true);
  };

  const handleBack = () => {
    setShowCreation(false);
    setSelectedSampleTemplate(null);
    setEditingTemplate(null);
  };

  return (
    <div className="p-3">
      {!showCreation ? (
        <TemplateListing
          onCreateNew={handleCreateNew}
          onSelectSample={handleSelectSample}
          onEditTemplate={handleEditTemplate}
        />
      ) : (
        <TemplateCreation
          onBack={handleBack}
          initialTemplate={selectedSampleTemplate}
          editTemplate={editingTemplate}
        />
      )}
    </div>
  );
};

export default Template;
